<template>
    <transition name="el-zoom-in-top">
        <div class="content-wrapper">
                                            <!-- Content Header (Page header) -->
        <section class="content-header">
            <h1>Shop Page<small><i class="ti-heart"></i><i class="ti-export"></i><i class="ti-printer"></i></small></h1>
            <ol class="breadcrumb">
                <li><router-link to="/"> <i class="ti-home"></i></router-link></li>
                <li><a href="#">Apps</a></li>
                <li class="active">Shop Page</li>
            </ol>
        </section>
            <!-- Main content -->
            <section class="content">
                      <div class="box" style="padding:30px;">

                          <div class="row">
						<div class="col-md-12">
							<!-- TABS -->
							<ul class="nav nav-tabs nav-tabs-shop-devin" role="tablist">
								<li class="" data-wow-delay="0.6s"><a href="#featured" data-toggle="tab" aria-expanded="false">featured</a></li>
								<li class="active" data-wow-delay="0.4s"><a href="#best" data-toggle="tab" aria-expanded="true">bestsellers</a></li>
								<li class="" data-wow-delay="0.2s"><a href="#new" data-toggle="tab" aria-expanded="false">new</a></li>
							</ul>

							<div class="tab-content">
								<!-- TAB PANEL ITEM-->
								<div role="tabpanel" class="tab-pane fade" id="featured">
									<div class="row">
										<!-- PRODUCT SINGLE -->
										<div class="col-md-3 col-sm-6">
											<div class="product-item">
												<div class="product-item-thumbnail text-center mb-15">
													<a class="product-item-thumbnail-link" href="#"></a>
													<span class="product-item-thumbnail-label">new</span>
													<img src="http://thymetheme.pl/vega/v102/assets/img/products/product-01.jpg" class="img-responsive" alt="product image">
													<div class="product-item-thumbnail-overlay">
														<a href="#" class="btn btn-default pulse"><span class="ti-heart mr-0"></span></a>
														<a href="#" class="btn btn-primary">add to cart</a>
													</div>
												</div>
												<div class="row">
													<div class="col-xs-6">
														<a class="h5" href="#">Product name</a>
													</div>

													<div class="col-xs-6 text-right">
														<del class="h5 text-muted product-item-price-old">$99.00</del>
														<span class="h5 product-item-price">$49.00</span>
													</div>
												</div>
											</div>
										</div>
										<!-- / PRODUCT SINGLE-->
										<!-- PRODUCT SINGLE -->
										<div class="col-md-3 col-sm-6">
											<div class="product-item">
												<div class="product-item-thumbnail text-center mb-15">
													<a class="product-item-thumbnail-link" href="#"></a>
													<span class="product-item-thumbnail-label">new</span>
													<img src="http://thymetheme.pl/vega/v102/assets/img/products/product-01.jpg" class="img-responsive" alt="product image">
													<div class="product-item-thumbnail-overlay">
														<a href="#" class="btn btn-default pulse"><span class="ti-heart mr-0"></span></a>
														<a href="#" class="btn btn-primary">add to cart</a>
													</div>
												</div>
												<div class="row">
													<div class="col-xs-6">
														<a class="h5" href="#">Product name</a>
													</div>

													<div class="col-xs-6 text-right">
														<del class="h5 text-muted product-item-price-old">$99.00</del>
														<span class="h5 product-item-price">$49.00</span>
													</div>
												</div>
											</div>
										</div>
										<!-- / PRODUCT SINGLE-->
										<!-- PRODUCT SINGLE -->
										<div class="col-md-3 col-sm-6">
											<div class="product-item">
												<div class="product-item-thumbnail text-center mb-15">
													<a class="product-item-thumbnail-link" href="#"></a>
													<span class="product-item-thumbnail-label">new</span>
													<img src="http://thymetheme.pl/vega/v102/assets/img/products/product-01.jpg" class="img-responsive" alt="product image">
													<div class="product-item-thumbnail-overlay">
														<a href="#" class="btn btn-default pulse"><span class="ti-heart mr-0"></span></a>
														<a href="#" class="btn btn-primary">add to cart</a>
													</div>
												</div>
												<div class="row">
													<div class="col-xs-6">
														<a class="h5" href="#">Product name</a>
													</div>

													<div class="col-xs-6 text-right">
														<del class="h5 text-muted product-item-price-old">$99.00</del>
														<span class="h5 product-item-price">$49.00</span>
													</div>
												</div>
											</div>
										</div>
										<!-- / PRODUCT SINGLE-->
										<!-- PRODUCT SINGLE -->
										<div class="col-md-3 col-sm-6">
											<div class="product-item">
												<div class="product-item-thumbnail text-center mb-15">
													<a class="product-item-thumbnail-link" href="#"></a>
													<span class="product-item-thumbnail-label">new</span>
													<img src="http://thymetheme.pl/vega/v102/assets/img/products/product-01.jpg" class="img-responsive" alt="product image">
													<div class="product-item-thumbnail-overlay">
														<a href="#" class="btn btn-default pulse"><span class="ti-heart mr-0"></span></a>
														<a href="#" class="btn btn-primary">add to cart</a>
													</div>
												</div>
												<div class="row">
													<div class="col-xs-6">
														<a class="h5" href="#">Product name</a>
													</div>

													<div class="col-xs-6 text-right">
														<del class="h5 text-muted product-item-price-old">$99.00</del>
														<span class="h5 product-item-price">$49.00</span>
													</div>
												</div>
											</div>
										</div>
										<!-- / PRODUCT SINGLE-->	
									</div>
								</div>
								<!--/ TAB PANEL ITEM -->

								<!-- TAB PANEL ITEM-->
								<div role="tabpanel" class="tab-pane fade active in" id="best">
									<div class="row">
										<!-- PRODUCT SINGLE -->
										<div class="col-md-3 col-sm-6">
											<div class="product-item">
												<div class="product-item-thumbnail text-center mb-15">
													<a class="product-item-thumbnail-link" href="#"></a>
													<span class="product-item-thumbnail-label">new</span>
													<img src="http://thymetheme.pl/vega/v102/assets/img/products/product-02.jpg" class="img-responsive" alt="product image">
													<div class="product-item-thumbnail-overlay">
														<a href="#" class="btn btn-default pulse"><span class="ti-heart mr-0"></span></a>
														<a href="#" class="btn btn-primary">add to cart</a>
													</div>
												</div>
												<div class="row">
													<div class="col-xs-6">
														<a class="h5" href="#">Product name</a>
													</div>

													<div class="col-xs-6 text-right">
														<del class="h5 text-muted product-item-price-old">$99.00</del>
														<span class="h5 product-item-price">$49.00</span>
													</div>
												</div>
											</div>
										</div>
										<!-- / PRODUCT SINGLE-->
										<!-- PRODUCT SINGLE -->
										<div class="col-md-3 col-sm-6">
											<div class="product-item">
												<div class="product-item-thumbnail text-center mb-15">
													<a class="product-item-thumbnail-link" href="#"></a>
													<span class="product-item-thumbnail-label">new</span>
													<img src="http://thymetheme.pl/vega/v102/assets/img/products/product-02.jpg" class="img-responsive" alt="product image">
													<div class="product-item-thumbnail-overlay">
														<a href="#" class="btn btn-default pulse"><span class="ti-heart mr-0"></span></a>
														<a href="#" class="btn btn-primary">add to cart</a>
													</div>
												</div>
												<div class="row">
													<div class="col-xs-6">
														<a class="h5" href="#">Product name</a>
													</div>

													<div class="col-xs-6 text-right">
														<del class="h5 text-muted product-item-price-old">$99.00</del>
														<span class="h5 product-item-price">$49.00</span>
													</div>
												</div>
											</div>
										</div>
										<!-- / PRODUCT SINGLE-->
										<!-- PRODUCT SINGLE -->
										<div class="col-md-3 col-sm-6">
											<div class="product-item">
												<div class="product-item-thumbnail text-center mb-15">
													<a class="product-item-thumbnail-link" href="#"></a>
													<span class="product-item-thumbnail-label">new</span>
													<img src="http://thymetheme.pl/vega/v102/assets/img/products/product-02.jpg" class="img-responsive" alt="product image">
													<div class="product-item-thumbnail-overlay">
														<a href="#" class="btn btn-default pulse"><span class="ti-heart mr-0"></span></a>
														<a href="#" class="btn btn-primary">add to cart</a>
													</div>
												</div>
												<div class="row">
													<div class="col-xs-6">
														<a class="h5" href="#">Product name</a>
													</div>

													<div class="col-xs-6 text-right">
														<del class="h5 text-muted product-item-price-old">$99.00</del>
														<span class="h5 product-item-price">$49.00</span>
													</div>
												</div>
											</div>
										</div>
										<!-- / PRODUCT SINGLE-->
										<!-- PRODUCT SINGLE -->
										<div class="col-md-3 col-sm-6">
											<div class="product-item">
												<div class="product-item-thumbnail text-center mb-15">
													<a class="product-item-thumbnail-link" href="#"></a>
													<span class="product-item-thumbnail-label">new</span>
													<img src="http://thymetheme.pl/vega/v102/assets/img/products/product-02.jpg" class="img-responsive" alt="product image">
													<div class="product-item-thumbnail-overlay">
														<a href="#" class="btn btn-default pulse"><span class="ti-heart mr-0"></span></a>
														<a href="#" class="btn btn-primary">add to cart</a>
													</div>
												</div>
												<div class="row">
													<div class="col-xs-6">
														<a class="h5" href="#">Product name</a>
													</div>

													<div class="col-xs-6 text-right">
														<del class="h5 text-muted product-item-price-old">$99.00</del>
														<span class="h5 product-item-price">$49.00</span>
													</div>
												</div>
											</div>
										</div>
										<!-- / PRODUCT SINGLE-->						
									</div>
								</div>
								<!--/ TAB PANEL ITEM -->

								<!-- TAB PANEL ITEM-->
								<div role="tabpanel" class="tab-pane fade" id="new">
									<div class="row">
										<!-- PRODUCT SINGLE -->
										<div class="col-md-3 col-sm-6">
											<div class="product-item">
												<div class="product-item-thumbnail text-center mb-15">
													<a class="product-item-thumbnail-link" href="#"></a>
													<span class="product-item-thumbnail-label">new</span>
													<img src="http://thymetheme.pl/vega/v102/assets/img/products/product-03.jpg" class="img-responsive" alt="product image">
													<div class="product-item-thumbnail-overlay">
														<a href="#" class="btn btn-default pulse"><span class="ti-heart mr-0"></span></a>
														<a href="#" class="btn btn-primary">add to cart</a>
													</div>
												</div>
												<div class="row">
													<div class="col-xs-6">
														<a class="h5" href="#">Product name</a>
													</div>

													<div class="col-xs-6 text-right">
														<del class="h5 text-muted product-item-price-old">$99.00</del>
														<span class="h5 product-item-price">$49.00</span>
													</div>
												</div>
											</div>
										</div>
										<!-- / PRODUCT SINGLE-->
										<!-- PRODUCT SINGLE -->
										<div class="col-md-3 col-sm-6">
											<div class="product-item">
												<div class="product-item-thumbnail text-center mb-15">
													<a class="product-item-thumbnail-link" href="#"></a>
													<span class="product-item-thumbnail-label">new</span>
													<img src="http://thymetheme.pl/vega/v102/assets/img/products/product-03.jpg" class="img-responsive" alt="product image">
													<div class="product-item-thumbnail-overlay">
														<a href="#" class="btn btn-default pulse"><span class="ti-heart mr-0"></span></a>
														<a href="#" class="btn btn-primary">add to cart</a>
													</div>
												</div>
												<div class="row">
													<div class="col-xs-6">
														<a class="h5" href="#">Product name</a>
													</div>

													<div class="col-xs-6 text-right">
														<del class="h5 text-muted product-item-price-old">$99.00</del>
														<span class="h5 product-item-price">$49.00</span>
													</div>
												</div>
											</div>
										</div>
										<!-- / PRODUCT SINGLE-->
										<!-- PRODUCT SINGLE -->
										<div class="col-md-3 col-sm-6">
											<div class="product-item">
												<div class="product-item-thumbnail text-center mb-15">
													<a class="product-item-thumbnail-link" href="#"></a>
													<span class="product-item-thumbnail-label">new</span>
													<img src="http://thymetheme.pl/vega/v102/assets/img/products/product-03.jpg" class="img-responsive" alt="product image">
													<div class="product-item-thumbnail-overlay">
														<a href="#" class="btn btn-default pulse"><span class="ti-heart mr-0"></span></a>
														<a href="#" class="btn btn-primary">add to cart</a>
													</div>
												</div>
												<div class="row">
													<div class="col-xs-6">
														<a class="h5" href="#">Product name</a>
													</div>

													<div class="col-xs-6 text-right">
														<del class="h5 text-muted product-item-price-old">$99.00</del>
														<span class="h5 product-item-price">$49.00</span>
													</div>
												</div>
											</div>
										</div>
										<!-- / PRODUCT SINGLE-->
										<!-- PRODUCT SINGLE -->
										<div class="col-md-3 col-sm-6">
											<div class="product-item">
												<div class="product-item-thumbnail text-center mb-15">
													<a class="product-item-thumbnail-link" href="#"></a>
													<span class="product-item-thumbnail-label">new</span>
													<img src="http://thymetheme.pl/vega/v102/assets/img/products/product-03.jpg" class="img-responsive" alt="product image">
													<div class="product-item-thumbnail-overlay">
														<a href="#" class="btn btn-default pulse"><span class="ti-heart mr-0"></span></a>
														<a href="#" class="btn btn-primary">add to cart</a>
													</div>
												</div>
												<div class="row">
													<div class="col-xs-6">
														<a class="h5" href="#">Product name</a>
													</div>

													<div class="col-xs-6 text-right">
														<del class="h5 text-muted product-item-price-old">$99.00</del>
														<span class="h5 product-item-price">$49.00</span>
													</div>
												</div>
											</div>
										</div>
										<!-- / PRODUCT SINGLE-->					
									</div>
								</div>
								<!--/ TAB PANEL ITEM -->
							</div>
							<!-- / TABS -->

						</div>
					</div>
                          <div class="row">
						<!-- PRODUCT SINGLE -->
						<div class="col-md-3 col-sm-6">
							<div class="product-item">
								<div class="product-item-thumbnail text-center mb-15">
									<a class="product-item-thumbnail-link" href="#"></a>
									<span class="product-item-thumbnail-label">new</span>
									<img src="http://thymetheme.pl/vega/v102/assets/img/products/product-01.jpg" class="img-responsive" alt="product image">
									<div class="product-item-thumbnail-overlay">
										<a href="#" class="btn btn-default pulse"><span class="ti-heart mr-0"></span></a>
										<a href="#" class="btn btn-primary">add to cart</a>
									</div>
								</div>
								<div class="row">
									<div class="col-xs-6">
										<a class="h5" href="#">Product name</a>
									</div>

									<div class="col-xs-6 text-right">
										<del class="h5 text-muted product-item-price-old">$99.00</del>
										<span class="h5 product-item-price">$49.00</span>
									</div>
								</div>
							</div>
						</div>
						<!-- / PRODUCT SINGLE-->
						<!-- PRODUCT SINGLE -->
						<div class="col-md-3 col-sm-6">
							<div class="product-item">
								<div class="product-item-thumbnail text-center mb-15">
									<a class="product-item-thumbnail-link" href="#"></a>
									<img src="http://thymetheme.pl/vega/v102/assets/img/products/product-01.jpg" class="img-responsive" alt="product image">
									<div class="product-item-thumbnail-overlay">
										<a href="#" class="btn btn-default pulse"><span class="ti-heart mr-0"></span></a>
										<a href="#" class="btn btn-primary">add to cart</a>
									</div>
								</div>
								<div class="row">
									<div class="col-xs-6">
										<a class="h5" href="#">Product name</a>
									</div>

									<div class="col-xs-6 text-right">
										<del class="h5 text-muted product-item-price-old">$99.00</del>
										<span class="h5 product-item-price">$49.00</span>
									</div>
								</div>
							</div>
						</div>
						<!-- / PRODUCT SINGLE-->
						<!-- PRODUCT SINGLE -->
						<div class="col-md-3 col-sm-6">
							<div class="product-item">
								<div class="product-item-thumbnail text-center mb-15">
									<a class="product-item-thumbnail-link" href="#"></a>
									<span class="product-item-thumbnail-label">new</span>
									<img src="http://thymetheme.pl/vega/v102/assets/img/products/product-01.jpg" class="img-responsive" alt="product image">
									<div class="product-item-thumbnail-overlay">
										<a href="#" class="btn btn-default pulse"><span class="ti-heart mr-0"></span></a>
										<a href="#" class="btn btn-primary">add to cart</a>
									</div>
								</div>
								<div class="row">
									<div class="col-xs-6">
										<a class="h5" href="#">Product name</a>
									</div>

									<div class="col-xs-6 text-right">
										<del class="h5 text-muted product-item-price-old">$99.00</del>
										<span class="h5 product-item-price">$49.00</span>
									</div>
								</div>
							</div>
						</div>
						<!-- / PRODUCT SINGLE-->
						<!-- PRODUCT SINGLE -->
						<div class="col-md-3 col-sm-6">
							<div class="product-item">
								<div class="product-item-thumbnail text-center mb-15">
									<a class="product-item-thumbnail-link" href="#"></a>
									<img src="http://thymetheme.pl/vega/v102/assets/img/products/product-01.jpg" class="img-responsive" alt="product image">
									<div class="product-item-thumbnail-overlay">
										<a href="#" class="btn btn-default pulse"><span class="ti-heart mr-0"></span></a>
										<a href="#" class="btn btn-primary">add to cart</a>
									</div>
								</div>
								<div class="row">
									<div class="col-xs-6">
										<a class="h5" href="#">Product name</a>
									</div>

									<div class="col-xs-6 text-right">
										<del class="h5 text-muted product-item-price-old">$99.00</del>
										<span class="h5 product-item-price">$49.00</span>
									</div>
								</div>
							</div>
						</div>
						<!-- / PRODUCT SINGLE-->
					</div>
                          
    </div>
            </section>
            <!-- /.content -->
        </div>
    </transition>
</template>
<script>
  export default {
    name: 'ShopHome'
  }
</script>




// WEBPACK FOOTER //
// ShopHome.vue?86ea011e